import { CircleCheck, TriangleAlert } from 'lucide-react';
import { type ReactNode } from 'react';
import { Alert, AlertDescription, AlertTitle } from '../../components/ui/alert';
import { cn } from '../../lib/utils';

// The shadcn `Alert` has no warning / success variants (and we don't patch the vendored file), so these add them
const severityClassNames = {
  warning:
    'border-amber-500/50 bg-amber-50 text-amber-900 dark:bg-amber-950/40 dark:text-amber-200 *:data-[slot=alert-description]:text-amber-900/90 dark:*:data-[slot=alert-description]:text-amber-200/90',
  success:
    'border-green-600/40 bg-green-50 text-green-900 dark:bg-green-950/40 dark:text-green-200 *:data-[slot=alert-description]:text-green-900/90 dark:*:data-[slot=alert-description]:text-green-200/90',
};

const severityIcons = {
  warning: <TriangleAlert />,
  success: <CircleCheck />,
};

/** A shadcn `Alert` with the MUI `Alert` severities we use (`warning`, `success`), an icon, a title and/or a text */
export const SeverityAlert = ({
  severity,
  title,
  children,
  className,
}: {
  severity: keyof typeof severityClassNames;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
}) => (
  <Alert className={cn(severityClassNames[severity], className)}>
    {severityIcons[severity]}
    {title && <AlertTitle>{title}</AlertTitle>}
    {children && <AlertDescription>{children}</AlertDescription>}
  </Alert>
);
